export { fatigue };

const fatigue = () => {
  return [
    {
      label: 'Summary',
      icon: 'dashboard',
      view: {
        type: 'table',
        content: [
          { field: 'assetName', header: 'Asset' },
          { field: 'fatigueTotalCount', header: 'Total Fatigue Trip Count' },
          { field: 'fatigueTotalTime', header: 'Total Fatigue Driving Time' },
        ],
      },
      pdf: {
        title: 'Fatigue Driving - Summary',
        colsWidth: [51, 103, 140, 109, 101, 100],
      },
    },
    {
      label: 'Breakdown',
      icon: 'event',
      view: {
        type: 'table',
        content: [
          { field: 'assetName', header: 'Asset' },
          {
            field: 'tripTime',
            header: 'Time',
          },
          {
            field: 'tripMin2',
            header: 'Duration',
          },
          {
            field: 'fatigueDuration',
            header: 'Fatigue Duration',
          },
          {
            field: 'idlingAcceptedAsBreak',
            header: 'Idling as Break?',
          },
          {
            field: 'tripDistance',
            header: 'Distance',
          },
          {
            field: 'tripIdlingCount',
            header: 'Idling Count',
          },
          {
            field: 'tripIdlingMin2',
            header: 'Idling Duration',
          },
          {
            field: 'startLocation',
            header: 'Start Location',
          },
          {
            field: 'coordinates',
            header: 'Coord',
            template: { component: 'GoogleMapLink' },
          },
          {
            field: 'endLocation',
            header: 'End Location',
          },
          {
            field: 'coordinates2',
            header: 'Coord',
            template: { component: 'GoogleMapLink' },
          },
          {
            field: 'status',
            header: 'Status',
          },
          {
            header: 'Actions',
            template: {
              component: 'ActionButtons',
              data: [
                {
                  text: 'View Trip Playback',
                  icon: 'icon-map',
                  iconPack: 'feather',
                  click: {
                    component: 'PlayBackV2',
                    data: { onReady: getPlayback },
                  },
                },
              ],
            },
          },
        ],
      },
      pdf: {
        title: 'Fatigue Driving - Breakdown',
        colsWidth: [101, 101, 70, 70, 70],
      },
    },
  ];
};

const summaryActions = async (self) => {
  return new Promise((resolve) => {
    let param = self.data.data.args;
    let args = self.data.rowData;
    let assetName = args.assetName;
    let reports = self.reportsContent.reportsData;
    let report = reports[param.type + 1];
    let array = report.filter((obj) => obj.assetName === assetName);

    let modal = JSON.parse(JSON.stringify(self.modalTableApi));

    // return array;
    modal.reportData = array;
    modal.table.content = deepClone(param.table);
    if (!param.noAction) {
      modal.table.content.pop();
    }
    modal.table.content.forEach((e) => {
      if (e.header == 'Coord' || e.header == 'Coords') {
        e.template.data = { component: 'GoogleMapEmbed' };
      }
    });
    modal.pdf.colsWidth = param.colsWidth;

    modal.title = `${param.title} - ${args.assetName}`;
    modal.pdf.title = modal.title;
    self.onReadyData = modal;

    resolve(true);
  });
};

const getModalTableData = async (self) => {
  let param = self.data.data.args;
  let args = self.data.rowData;
  let url = param.summary
    ? 'getIndividualSummaryBreakdown'
    : 'getIndividualHistoryBreakdown';
  let options = param.summary
    ? {
        timeRange: self.timeRange,
        uid: self.userInfo.uid,
        unitId: args.unitId,
        assetId: args.assetId,
        assetName: args.assetName,
        configuration: self.configuration,
        type: param.type,
        geoPOIData: self.geoPOIData,
      }
    : {
        timeRange: tripTimerange(args.tripTime).timeRange,
        uid: self.userInfo.uid,
        units: [args.unitId],
        geoPOIData: self.geoPOIData,
        type: param.type,
        configuration: self.configuration,
      };
  let modal = JSON.parse(JSON.stringify(self.modalTableApi));
  let field = {
    Trips: 'tripCount',
    Idling: 'idlingCount',
    Parking: 'parkCount',
  };
  return new Promise((resolve) => {
    if (args[field[param.type]] && args[field[param.type]] == 0) {
      self.$vs.notify({
        title: 'Error',
        text: 'No data available',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning',
      });
      resolve(false);
    } else {
      // self.isLoading = true;
      // console.log(options);
      self.$http
        .post('report/table', options)
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            let breakdownData = [];
            breakdownData.push({
              assetId: args.assetId,
              type: param.type,
              assetName: args.assetName,
              arr: response.data.reportData,
            });
            // console.log(response);
            breakdownData[0].arr.forEach((e) => {
              modal.reportData.push(e);
            });
            // console.log(breakdownData);
            // modal.reportData = breakdownData;
            modal.table.content = deepClone(param.table);
            if (!param.noAction) {
              modal.table.content.pop();
            }
            modal.table.content.forEach((e) => {
              if (e.header == 'Coord' || e.header == 'Coords') {
                e.template.data = { component: 'GoogleMapEmbed' };
              }
            });
            modal.pdf.colsWidth = param.colsWidth;
            // self.forceRender += 1;
            // self.activeTab = self.breakdownData.length + 5;
            // self.isLoading = false;

            modal.title = `${param.type} - ${args.assetName}`;
            modal.pdf.title = modal.title;
            self.onReadyData = modal;

            resolve(true);
          } else {
            // self.isLoading = false;
            if (response.data.error) {
              self.$vs.notify({
                title: 'Error',
                text: 'Try again later.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
              });
              resolve(false);
            } else {
              self.$vs.notify({
                title: 'Error',
                text: 'Try again later.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
              });
              resolve(false);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
          // self.isLoading = false;

          self.$vs.notify({
            title: 'Error',
            text: 'Try again later.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
          resolve(false);
        });
    }
  });
};

const tripTimerange = (tripTime) => {
  const time = tripTime.split('-');
  const timeRange = [0, 0];
  // time[0] = time[0].substring(0, time[0].length);
  // time[1] = time[1].substring(1, time[1].length);
  timeRange[0] = moment(time[0], 'DD/MM/YYYY | hh:mm:ss').toISOString();
  timeRange[1] = moment(time[1], 'DD/MM/YYYY | hh:mm:ss').toISOString();
  return { timeRange, time };
};

const getPlayback = async (self) => {
  let args = self.data.rowData;
  return new Promise((resolve) => {
    self.isLoading = true;
    self.$http
      .post(`singleUnitPlayback3`, {
        timeRange: tripTimerange(args.tripTime).timeRange,
        geoPOIData: self.geoPOIData,
        configuration: {
          speedType: '',
          speedLimit: 0,
        },
        platform: 'Web',
        uid: undefined,
        units: [args.unitId],
        // mode: 1,
      })
      .then(function (response) {
        if (response.status == 200 && response.data.success) {
          self.selected.routeArray = response.data.routeArray;
          self.selected.routePath = response.data.routePath;
          self.selected.assetName = args.assetName;
          self.popupActive = true;
          self.isLoading = false;
          self.loadMap = true;
          self.onReadyData.title = `${args.assetName}`;
          // console.log(self);
          // console.log(tripTimerange(args.tripTime));
          self.selected.timeRange = tripTimerange(args.tripTime).timeRange;
          resolve(true);
        } else {
          self.isLoading = false;
          if (response.data.error) {
            self.$vs.notify({
              title: 'Error',
              text: 'Try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
            resolve(false);
          } else {
            self.$vs.notify({
              title: 'Error',
              text: 'Try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
            resolve(false);
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        self.isLoading = false;

        self.$vs.notify({
          title: 'Error',
          text: 'Try again later.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
        resolve(false);
      });
  });
};

function deepClone(obj, clonesMap = new WeakMap()) {
  // Check if the object is already cloned
  if (clonesMap.has(obj)) {
    return clonesMap.get(obj);
  }

  // Handle non-object types and null
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  // Handle special objects like Date
  if (obj instanceof Date) {
    return new Date(obj);
  }

  // Handle arrays
  if (Array.isArray(obj)) {
    const arrClone = [];
    clonesMap.set(obj, arrClone);
    for (let i = 0; i < obj.length; i++) {
      arrClone[i] = deepClone(obj[i], clonesMap);
    }
    return arrClone;
  }

  // Handle regular objects
  const objClone = {};
  clonesMap.set(obj, objClone);
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      objClone[key] = deepClone(obj[key], clonesMap);
    }
  }

  return objClone;
}
